import {useState} from "react";
import styled from 'styled-components/macro';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboard, faGavel, faReply, faUser} from '@fortawesome/free-solid-svg-icons';

import {Tooltip} from "@chakra-ui/react";
import {useProfile} from "../api/user";
import {useFeedback} from "../store/feedback";
import {useBaseCommunity} from "../store/hooks";
import {useReports} from "../api/moderation";
import {useModal, useRelativeTime} from "../store";
import Ban from "./mod/ban";
import Notes from "./mod/notes";
import ModMessage from "./mod/mod_message";
import NavLink from "./nav_link";
import {themecolors} from "../utils/themecolors";
import {Clipboard, Gavel, Reply, Shield, User} from "lucide-react";

const Icon = styled.span``;
const Item = styled.div``;
const ReportList = styled.div``;
const Reporter = styled.span``;
const Reason = styled.span``;

export const Reports = styled(({className, id, type, style}) => {
        const {feedbackCh} = useFeedback();
        const reports = useReports(feedbackCh, id, type);
        return (
            <ReportList style={style} className={className}>
                {reports?.map((report) => (
                    <Item key={report.id}>
                        <Reporter>
                            <NavLink href={`/u/${report.author}`}>
                                {`u/${report.author} •`}
                            </NavLink>
                        </Reporter>
                        <Reason>
                            {`${report.reason}`}
                        </Reason>
                    </Item>
                ))}
            </ReportList>
        )
    }
)`
  margin-top: 8px;
  background-color: #ffebc2;
  padding: 12px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
  color: ${({theme}) => theme.placeholder_black_1};

  ${Reporter} {
    font-weight: 500;
    margin-right: 4px;
  }

  ${Item} {
    display: flex;
    margin-bottom: 6px;
    flex-wrap: wrap;
  }

  ${Item}:last-of-type {
    margin-bottom: 0;
  }
`;

const UserHistory = styled(({author, onClick}) => {
        const baseCommunity = useBaseCommunity();
        const {feedbackCh} = useFeedback();
        const profile = useProfile(feedbackCh, author);
        const age = `Age: ${useRelativeTime(profile?.created, true)} • Post Score: ${profile?.post_score} • Comment Score: ${profile?.comment_score}`;
        return (
            <>
                <Tooltip label={`${age}`}>
                    <Icon>
                        {baseCommunity === "TheDonald" ? <FontAwesomeIcon onClick={onClick} icon={faUser}/> : <User size={14}/>}
                    </Icon>
                </Tooltip>
            </>
        )
    }
)`
  margin-left: 4px;
  cursor: pointer;
  display: flex;

  svg {
    margin-left: 6px;
    color: ${({theme}) => theme.placeholder_gray_2};
  }`;

export const ModTools = styled(({className, post, comment}) => {
        const baseCommunity = useBaseCommunity();
        const modal = useModal();
        const author = post ? post.author : comment.author;
        const [profile, setProfile] = useState(false);
        const [showAllActions, setShowAllActions] = useState(false);
        const handleProfile = () => {
            setProfile(!profile);
        };
        const handleBan = () => {
            modal.open(Ban, {post, comment});
        };
        const handleNotes = () => {
            modal.open(Notes, {post, comment});
        };
        const handleMessage = () => {
            modal.open(ModMessage, {post, comment});
        };
        const handleShowAllActions = () => {
            setShowAllActions(!showAllActions);
        };
        return (
            <span className={classNames(className, {pdw: baseCommunity === "TheDonald"})}>

                {baseCommunity === "TheDonald" ? (
                    <>
                        {profile ? <UserHistory onClick={handleProfile} author={author}/>
                            : <Icon><FontAwesomeIcon onClick={handleProfile} icon={faUser}/></Icon>
                        }
                        <Icon><FontAwesomeIcon onClick={handleBan} icon={faGavel}/></Icon>
                        <Icon><FontAwesomeIcon onClick={handleNotes} icon={faClipboard}/></Icon>
                        <Icon><FontAwesomeIcon onClick={handleMessage} icon={faReply}/></Icon>
                    </>
                ) : (
                    <>
                        <Icon>
                            <Shield size={14} onClick={handleShowAllActions}/>
                        </Icon>
                        {showAllActions &&
                        <>
                            {profile ? <UserHistory onClick={handleProfile} author={author}/>
                                :
                                <Icon><User size={14} onClick={handleProfile}/></Icon>
                            }

                            <Icon><Gavel size={14} onClick={handleBan}/></Icon>
                            <Icon><Clipboard size={14} onClick={handleNotes}/></Icon>
                            <Icon><Reply size={14} onClick={handleMessage}/></Icon>
                        </>
                        }
                    </>
                )}

            </span>
        )
    }
)`
  display: flex;
  align-items: center;

  svg {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_zero_impact_text};
  }

  ${Icon} {
    margin-left: 6px;
    cursor: pointer;
  }

  &.pdw {
    display: inline;
    margin-left: 4px;

    svg {
      margin-left: 6px;
      color: ${({theme}) => theme.placeholder_gray_2};
    }

    ${Icon} {
      margin-left: 0;
    }
  }`;

export default ModTools;
